// Chart Colors Utility
// Centralized color definitions for all dashboard charts
// Maps color token names to hex values

export const chartColors = {
  // Whites and blacks
  'white': '#FFFFFF',
  'black': '#000000',

  // True Blue palette
  'true-blue-0': 'hsla(204, 100%, 96%, 1)',
  'true-blue-5': 'hsla(203, 85%, 89%, 1)',
  'true-blue-10': 'hsla(204, 81%, 83%, 1)',
  'true-blue-20': 'hsla(204, 78%, 71%, 1)',
  'true-blue-60': 'hsla(204, 100%, 40%, 1)',
  'true-blue-70': 'hsla(206, 100%, 38%, 1)',

  // Salem palette
  'salem-0': 'hsla(160, 100%, 96%, 1)',
  'salem-40': 'hsla(160, 39%, 56%, 1)',
  'salem-60': 'hsla(160, 56%, 39%, 1)',

  // Fire Engine Red palette
  'fire-engine-red-0': '#FFE6E0',
  'fire-engine-red-5': '#FFD9CC',
  'fire-engine-red-10': '#FFCCB8',
  'fire-engine-red-15': '#FFBFA3',
  'fire-engine-red-20': '#FFB28F',
  'fire-engine-red-30': '#FF8F66',
  'fire-engine-red-40': '#FF6B3D',
  'fire-engine-red-50': '#FF4714',
  'fire-engine-red-60': '#E62E00',
  'fire-engine-red-70': '#CC1F00',
  'fire-engine-red-80': '#B81400',
  'fire-engine-red-90': '#990F00',
  'fire-engine-red-100': '#7A0A00',

  // Mango Orange palette
  'mango-orange-30': '#FFCA52',
  'mango-orange-40': '#F9A825',

  // Apple Green palette
  'apple-green-40': '#429A35',

  // Rhythm palette
  'rhythm-0': 'hsla(240, 100%, 98%, 1)',
  'rhythm-40': 'hsla(240, 11%, 56%, 1)',

  // Grays
  'gray-80': '#C9CBCF',
  'gray-90': '#E3E4E8',

  // Samon Pink
  'salmon-pink-50': '#E87662',

  // Golden Rod
  'golden-rod-50': '#F3C469',

  // Forest Green
  'forest-green-50': '#3C977D',

  // Financial Health
  'financial-health-high-unlikely': '#E66751E5',
  'financial-health-unlikely': '#EF9A5CE5',
  'financial-health-possibly': '#F2BE59E5',
  'financial-health-likely': '#1DB47EE5',
  'financial-health-highly-likely': '#278B6FE5'
} as const

// Helper functions for common use cases
export const getScoreColor = (score: number): string => {
  if (score >= 75) return chartColors['financial-health-highly-likely']
  if (score >= 65) return chartColors['financial-health-likely']
  if (score >= 45) return chartColors['financial-health-possibly']
  if (score >= 35) return chartColors['financial-health-unlikely']
  return chartColors['financial-health-high-unlikely']
}

export const getFinancialHealthColor = (current: number, benchmark: number, isHigherBetter: boolean = true): string => {
  if (isHigherBetter) {
    return current >= benchmark ? chartColors['salem-60'] : chartColors['fire-engine-red-70']
  } else {
    return current <= benchmark ? chartColors['salem-60'] : chartColors['fire-engine-red-70']
  }
}

export type ChartColors = typeof chartColors
